<ckeditor [formControl]="editorControl" [required]="requiredFlag" debounce="500" (paste)="onPaste($event)"
    (change)="onChange($event)" [config]="{ height : editorHeight}">
</ckeditor>